import React from 'react';
import './btn.css'

const Btn = (props) => {
    return (<>
        <button className='btn' onClick={props.onClick}> {/* Added onClick here */}
            {props.btn}
        </button>
    </>  );
}
 
export default Btn;